define('Shopping.EntryPoint', [
  'Header.View.Extension',
  'TechSpecs',
  'MachineFit',
  'MachineLookUp',
  'PriceMatch',
  'ProductDetails.Extension',
  'ProductDetails.QuickView.View.Extension',
  'Facets.ItemCell.View.Extension',
  'Facets.Browse.View.Extension',
  'Facets.FacetedNavigationItemCategory.View.Extension',
  'GlobalViews.ShowingCurrent.View.Extension',
  'RecentlyViewedItems.View.Extension',
  'ItemRelations.Correlated.View.Extension'
], function (
  HeaderViewExtension,
  TechSpecs,
  MachineFit,
  MachineLookUp,
  PriceMatch,
  ProductDetailsExtension,
  ProductDetailsQuickViewViewExtension,
  FacetsItemCellViewExtension,
  FacetsBrowseViewExtension,
  FacetsFacetedNavigationItemCategoryViewExtension,
  GlobalViewsShowingCurrentViewExtension,
  RecentlyViewedItemsViewExtension,
  ItemRelationsCorrelatedViewExtension
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      TechSpecs.mountToApp(container);
      MachineFit.mountToApp(container);
      MachineLookUp.mountToApp(container);
      PriceMatch.mountToApp(container);
      ProductDetailsExtension.mountToApp(container);
    }
  };
});
